import { render, staticRenderFns } from "./PaymentsTable.vue?vue&type=template&id=1aa2f1ea"
import script from "./PaymentsTable.vue?vue&type=script&lang=ts"
export * from "./PaymentsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports